<mat-menu #menu [hasBackdrop]="true" [class]="'pencil-mat-menu light-scheme'">
  <ng-container *ngFor="let option of options$ | async">
    <div
      [appTooltip]="
        option.value === RecordingAccess.ADMINS
          ? ('Only admins can set this access level' | translate)
          : ('Public recordings links are not permitted in this institution' | translate)
      "
      [appTooltipDisabled]="
        selectedValue === option.value ||
        !(
          (option.value === RecordingAccess.PUBLIC && !enablePublicAccess) ||
          (option.value === RecordingAccess.ADMINS && !enableAdminAccess)
        )
      "
      [appTooltipPlacement]="'center-start'"
      [appTooltipArrow]="'right'"
    >
      <app-pencil-menu-item
        [icon]="''"
        [iconConfig]="{ type: IconTypes.matIcon }"
        [label]="option.label"
        [subtitle]="option.subtitle"
        [renderCheckIcon]="selectedValue === option.value"
        [selected]="selectedValue === option.value"
        [disabled]="option.disabled"
        (clickEvent)="onOptionClick(option)"
      >
      </app-pencil-menu-item>
    </div>
  </ng-container>
</mat-menu>
